App.StoryFrameEditController = Em.Controller.extend
  session: Em.inject.service()

  env: Em.inject.service('environment')

  storyFrameBinding: 'model'

  banner: null

  isSaving: false
  colorValue: "#ffffff"
  contentColorValue: "#181818"
  isColorpickerShown: false
  isContentColorpickerShown: false

  selectedFrameVariant: null
  selectedButtonVariant: null
  selectedContentStyleVariant: null

  frameVariants: (->
    [
      { id: 'image', name: Em.I18n.t 'story_frame_edit.frame_variant.image' },
      { id: 'text', name: Em.I18n.t 'story_frame_edit.frame_variant.text'}
    ]
  ).property()

  buttonVariants: (->
    [
      { id: 'primary', name: Em.I18n.t 'story_frame_edit.button_variant.primary' },
      { id: 'secondary', name: Em.I18n.t 'story_frame_edit.button_variant.secondary'}
    ]
  ).property()

  contentStyleVariants: (->
    [
      { id: 'default', name: Em.I18n.t 'story_frame_edit.content_style.default' },
      { id: 'additional', name: Em.I18n.t 'story_frame_edit.content_style.additional'},
      { id: 'centered', name: Em.I18n.t 'story_frame_edit.content_style.centered'}
    ]
  ).property()


  showTextParameters: Em.computed.equal('storyFrame.frame_variant', 'text')

  selectedFrameVariantObserver: (->
    variant = @get('selectedFrameVariant')
    frame = @get('storyFrame')
    Em.set(frame, 'frame_variant', variant.id)
  ).observes('selectedFrameVariant')

  selectedButtonVariantObserver: (->
    variant = @get('selectedButtonVariant')
    frame = @get('storyFrame')
    Em.set(frame, 'button_variant', variant.id)
  ).observes('selectedButtonVariant')

  selectedContentStyleVariantObserver: (->
    variant = @get('selectedContentStyleVariant')
    frame = @get('storyFrame')
    Em.set(frame, 'content_style', variant.id)
  ).observes('selectedContentStyleVariant')

  storyFramesObserver: (->
    banner = @get('banner')
    return unless banner
    currentFrame = banner.get('story_frames').find (frame) =>
      frame.id is @get('storyFrame.id')
    @set('storyFrame.photo', currentFrame.photo) if currentFrame
  ).observes('banner.story_frames.@each')
  
  storyFrameObserver: (->
    currentFrame = @get('storyFrame')
    return unless currentFrame

    frameVariant = @get('frameVariants').find (variant) => variant.id is (currentFrame.frame_variant || 'image')
    Em.set(currentFrame, 'frame_variant', frameVariant.id) 
    @set('selectedFrameVariant', frameVariant)

    buttonVariant = @get('buttonVariants').find (variant) => variant.id is (currentFrame.button_variant || 'primary')
    Em.set(currentFrame, 'button_variant', buttonVariant.id) 
    @set('selectedButtonVariant',buttonVariant)

    contentStyleVariant = @get('contentStyleVariants').find (variant) => variant.id is (currentFrame.content_style || 'default')
    Em.set(currentFrame, 'content_style', contentStyleVariant.id)
    @set('selectedContentStyleVariant', contentStyleVariant)
    
    colorValue = currentFrame?.background_color || @get('colorValue')
    Em.set(currentFrame, 'background_color', colorValue)
    @set('colorValue', colorValue)

    contentColorValue = currentFrame?.content_text_color || @get('contentColorValue')
    Em.set(currentFrame, 'content_text_color', contentColorValue)
    @set('contentColorValue',contentColorValue)
  ).observes('storyFrame').on('init')


  frameButtonText:(->
    @get('storyFrame.button_text') or Em.I18n.t 'story_frame_edit.button_text'
  ).property('storyFrame.button_text')

  showFrameButton: (->
    @get('storyFrame.button_text') or @get('storyFrame.url')
  ).property('storyFrame.button_text', 'storyFrame.url')

  previewStyle: (->
    frame = @get('storyFrame')
    color = frame?.background_color

    return ''.htmlSafe() unless color
    return "background-color: #{color}".htmlSafe()
  ).property('storyFrame.background_color')

  contentPreviewStyle: (->
    frame = @get('storyFrame')
    color = frame?.content_text_color

    return ''.htmlSafe() unless color
    return "background-color: #{color}".htmlSafe()
  ).property('storyFrame.content_text_color')

  contentTextColorStyle: (->
    frame = @get('storyFrame')
    color = frame?.content_text_color

    return ''.htmlSafe() unless color
    return "color: #{color}".htmlSafe()
  ).property('storyFrame.content_text_color')
  
  actions: 
    discardChanges: ->
      @transitionToRoute 'banners.banner.edit', @get('banner')
      false
    
    acceptChanges: ->
      banner = @get('banner')
      @set('isSaving', true)
      banner.save().then =>
        @set('isSaving', false)
        @transitionToRoute 'banners.banner.edit', banner
  
    delete: ->
      banner = @get('banner')
      frame = @get('storyFrame')
      if confirm Em.I18n.t 'story_frame_edit.save_banner_for_edit'
        @transitionToRoute 'banners.banner.edit', @get('banner')
        findedFrame = banner.get('story_frames').find (_frame) => _frame.id is frame.id
        Em.set(findedFrame, '_destroy', 1)
        banner.save().then =>
          banner.reload()

    toggleColorpicker:  ->
      @toggleProperty('isColorpickerShown')
      false
    
    toggleContentColorpicker: ->
      @toggleProperty('isContentColorpickerShown')
      false

    colorChanged: (value) ->
      @set('storyFrame.background_color', value)
      @set('isColorpickerShown', false)
      false
    
    contentColorChanged: (value) ->
      @set('storyFrame.content_text_color', value)
      @set('isContentColorpickerShown', false)
      false
